import React from 'react'
import { FaCode } from "react-icons/fa";
import { FaReact, FaNodeJs,  } from "react-icons/fa";
import { SiTailwindcss, SiRedux, SiMongodb, SiFirebase, SiNextdotjs, SiExpress,  } from "react-icons/si";
import StepsConnectHRPng from "../assets/images/SCCalendar.png";
import PizzaAppImage from "../assets/images/PizzaApp.png";
import DashboardAppImage from "../assets/images/DashboardApp.png";
import ProjectCard from '../components/ProjectCard';

const ProjectsSection = () => {

    const projects = [
        {
            id: "eu-startup",
            name: "EU Start Up",
            href: "#",
            techStack: [
                { label: "Next.js", icon: <SiNextdotjs className="text-black dark:text-white w-full" /> },
                { label: "React", icon: <FaReact className="text-cyan-500 w-full" /> },
                { label: "Tailwind", icon: <SiTailwindcss className="text-sky-400" /> },
                { label: "Node.js", icon: <FaNodeJs className="text-lime-500 w-full" /> },
                { label: "Express.js", icon: <SiExpress className="text-gray-500 w-full" /> },
                { label: "Firebase", icon: <SiFirebase className="text-yellow-500" /> },
                { label: "MongoDB", icon: <SiMongodb className="text-green-600 w-full" /> },
                { label: "Storybook", icon: <FaCode className="text-pink-500 w-full" /> },
            ],
            summary: "An AI-powered recruitment platform built in a monorepo structure, featuring modules for HR, candidates, and administration using Next.js. The project includes a design system built with Storybook and a backend powered by Node.js, Express, and Firebase.",
            img: StepsConnectHRPng
        },
        {
            id: "pizza-ordering-app",
            name: "Pizza Ordering App",
            href: "https://nextjs-food-order-app.vercel.app/",
            techStack: [
                { label: "Next.js", icon: <SiNextdotjs className="text-black dark:text-white w-full" /> },
                { label: "React", icon: <FaReact className="text-cyan-500 w-full" /> },
                { label: "MongoDB", icon: <SiMongodb className="text-green-600 w-full" /> },
                { label: "Express.js", icon: <SiExpress className="text-gray-500 w-full" /> },
                { label: "Cloudinary", icon: <FaCode className="text-blue-500 w-full" /> },
            ],
            summary: "A full-stack e-commerce pizza ordering application featuring a seamless user experience, secure PayPal payment integration, and a robust backend for managing orders and inventory.",
            img: PizzaAppImage
        },
        {
            id: "dashboard-app",
            name: "E-Commerce Dashboard App",
            href: "#",
            techStack: [
                { label: "React", icon: <FaReact className="text-cyan-500 w-full" /> },
                { label: "Algorithms", icon: <FaCode className="text-purple-500 w-full" /> },
                { label: "Node.js", icon: <FaNodeJs className="text-lime-500 w-full" /> },
                { label: "Express.js", icon: <SiExpress className="text-gray-500 w-full" /> },
                { label: "REST APIs", icon: <FaCode className="text-red-500 w-full" /> },
            ],
            // summary: "A set of REST APIs built with Node.js and Express that solve maze problems using Breadth-First Search (BFS) and Depth-First Search (DFS) algorithms. Optimized for performance and scalability.",
            summary: "A comprehensive e-commerce dashboard application built with React, featuring advanced algorithms for data processing and visualization, designed to enhance user experience and operational efficiency.",
            img: DashboardAppImage
        },
    ];
  return (
    <section className='bg-gradient-to-t dark:from-[#0e0e10] from-[#fff] from-50% to-transparent to-100% scroll-m-16' id='projects'>
        <div className='flex flex-col gap-8 max-w-7xl mx-auto'>
            <div className='relative pt-8 pb-32 max-2xl:px-8 max-md:pt-4'>
                <div className='mx-auto max-w-7xl py-8'>
                    <div className='flex gap-4 items-center justify-center text-center'>
                        <FaCode className='text-3xl dark:text-white text-blacktext'/>
                        <h2 className='font-bold text-3xl max-xl:text-3xl max-md:text-2xl  dark:text-white text-blacktext'>Projects <b className='bg-gradient-to-r from-riptide-500 to-mint-400 dark:from-riptide-500 dark:to-mint-500 text-transparent bg-clip-text'>Completed</b></h2>
                    </div>
                    <p className='z-2 text-center mx-auto text-lg max-xl:text-base max-w-2xl dark:text-gray-200 text-blacktext my-6 leading-6 font-medium'>I love <b className=' bg-gradient-to-r  from-riptide-500 to-mint-500 dark:from-riptide-300 dark:to-mint-200 text-transparent bg-clip-text'>turning ideas into real projects.</b> <br /> Here I show you some of the <b className=' bg-gradient-to-r  from-riptide-500 to-mint-500 dark:from-riptide-300 dark:to-mint-200 text-transparent bg-clip-text'>developments</b> that I've worked on, applying technology, design, and lots of creativity. <b className=' bg-gradient-to-r  from-riptide-500 to-mint-500 dark:from-riptide-300 dark:to-mint-200 text-transparent bg-clip-text'>Check them out!</b></p>
                </div>
                {/* <div className='mx-auto max-w-7xl grid grid-cols-3 max-lg:grid-cols-2 max-md:grid-cols-1 gap-5 p-2 py-4 max-h-[150vh] overflow-hidden transition-[max-height] duration-500 ease-in-out'> */}
                <div className='mx-auto max-w-7xl grid grid-cols-3 max-lg:grid-cols-2 max-md:grid-cols-1 gap-5 p-2 py-4 max-h-[300vh] overflow-hidden transition-[max-height] duration-500 ease-in-out'>
                    {projects.map((item)=>(
                        <ProjectCard key={item.id} name={item.name} summary={item.summary} techStack={item.techStack} img={item.img} href={item.href}/>
                    ))}
                </div>
                <div className='absolute bottom-0 left-0 w-full flex justify-center text-center bg-gradient-to-t from-[#FBFEFD] dark:from-[#0e0e10] from-55% to-transparent to-100% pb-30 pt-52 hidden'></div>
            </div>
        </div>
    </section>
  )
}

export default ProjectsSection